import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import SalesList from "./SalesList";
import SaleAdd from "./SaleAdd";
import SaleStats from "./SaleStats";
import SaleOrders from "./SaleOrders";
import SaleDebug from './SaleDebug';
import SaleEditOrder from "./SaleEditOrder";
import SaleComms from "./SaleComms";

export default function Sales() {
  return (
    <Routes>
      <Route path="/" element={<SalesList />} />
      <Route path="/new" element={<SaleAdd />} />
      <Route path="/stats" element={<SaleStats />} />
      <Route path="/orders" element={<SaleOrders />} />
      <Route path="/comms" element={<SaleComms />} />
      <Route path="/debug" element={<SaleDebug />} />
      <Route path="/order/:id" element={<SaleEditOrder />} />
    </Routes>
  )
}
